import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import s from '../../../assets/styles/style.sass';
import s2 from './serviceDetailDialog.sass';

class serviceDetailDialog extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    modal: PropTypes.bool.isRequired,
    onClickShow: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    let langType = props.currentLocale.split('-')[0]; // en-SG
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    if (lang === 'hk') {
      langType = `${langType}-${lang}`;
    } else {
      langType = lang;
    }

    this.state = {
      modal: props.modal,
      modelDataText: require(`../../../assets/src/scripts/gogovan/order/${lang}/${langType}.json`),
    };
    this.toggle = this.toggle.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.modal === true && this.props.modal !== true) {
      this.setState({
        modal: true,
      });
    }
  }

  toggle() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => {
        this.props.onClickShow(this.state.modal);
      },
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        id="serviceDetail"
        contentClassName={` ${s2.resizeModalWidth} ${s2.detailServicefontSize}`}
        className={`${s2.serviceDetail} ${s.infoPopup} ${
          s2.resizeModalPosition
        } ${s2.infoNoRadiusAndResize}`}
        zIndex={9999}
        style={{ fontFamily: 'Helvetica,sans-serif' }}
        size="lg"
      >
        <Button
          outline
          color="link"
          onClick={this.toggle}
          className={`${s2.infoCloseRightButton}`}
        />
        <ModalHeader
          style={{
            color: 'white',
            backgroundColor: '#006a96',
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px',
          }}
          className={`${s2.modalHeader}`}
        >
          <span style={{ margin: '54px 40px 30px', fontSize: '33px' }}>
            {this.state.modelDataText.order.service_content_headline}
          </span>
        </ModalHeader>
        <ModalBody style={{ padding: '30px 60px 60px 40px' }}>
          <div
            className={`${s2.serviceDetailContainer} text-centered`}
            data-close="false"
          >
            <div className={`${s2.serviceDetailContentContainer}`}>
              <p>{this.state.modelDataText.order.service_content_content}</p>
              <br />
              <div>
                <div
                  className={`${s2.serviceDetailDescHeadline} ${
                    s.globalTextBlue
                  }`}
                >
                  <h2 className={`${s2.h2MarginBottom}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_fleets_header
                    }
                  </h2>
                </div>
                <hr />
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_icon_ser_van_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_icon_ser_van_body
                    }
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_icon_ser_10ftlorry_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_icon_ser_10ftlorry_body
                    }
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_icon_ser_14ftlorry_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_icon_ser_14ftlorry_body
                    }
                  </Col>
                </Row>
              </div>

              {/* additional services */}
              <div className={`${s2.serviceAddtionalType}`}>
                <div
                  className={`${s2.serviceDetailDescHeadline} ${
                    s.globalTextBlue
                  }`}
                >
                  <h2 className={`${s2.h2MarginBottom}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_additional_header
                    }
                  </h2>
                </div>
                <hr />
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_english_speaking_driver_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_english_speaking_driver_body
                    }
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_goodsg_longer_than_6ft_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_goodsg_longer_than_6ft_body
                    }
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_borrow_carts_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_borrow_carts_body
                    }
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_forklift_rental_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_forklift_rental_body
                    }
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {this.state.modelDataText.order.service_content_mover_title}
                  </Col>
                  <Col md="10">
                    {this.state.modelDataText.order.service_content_mover_body}
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {this.state.modelDataText.order.service_content_pets_title}
                  </Col>
                  <Col md="10">
                    {this.state.modelDataText.order.service_content_pets_body}
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_new_vehicle_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_new_vehicle_body
                    }
                  </Col>
                </Row>
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col xs="2" sm="2" md="2" className={`${s2.orderSmallTitle}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_dumper_construction_waste_title
                    }
                  </Col>
                  <Col md="10">
                    {
                      this.state.modelDataText.order
                        .service_content_dumper_construction_waste_body
                    }
                  </Col>
                </Row>
              </div>

              {/* hourly */}
              <div className={`${s2.serviceAddtionalType}`}>
                <div
                  className={`${s2.serviceDetailDescHeadline} ${
                    s.globalTextBlue
                  }`}
                >
                  <h2 className={`${s2.h2MarginBottom}`}>
                    {
                      this.state.modelDataText.order
                        .service_content_hourly_header
                    }
                  </h2>
                </div>
                <hr />
                <Row className={`${s2.serviceVehicleType}`}>
                  <Col>
                    {
                      this.state.modelDataText.order
                        .service_content_hourly_rental_body
                    }
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
});
export default connect(mapState)(
  withStyles(bootstrap, s, s2)(serviceDetailDialog),
);



// WEBPACK FOOTER //
// ./src/routes/order/popup/serviceDetailDialog.js